import { memo } from 'react'

interface IMailIconProps {
  className?: string
}

const MailIcon: React.FC<IMailIconProps> = memo(({ className = '' }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M2.01721 14.8999C1.57721 14.8999 1.20054 14.7432 0.887206 14.4299C0.573872 14.1165 0.417206 13.7399 0.417206 13.2999V3.69985C0.417206 3.25985 0.573872 2.88319 0.887206 2.56985C1.20054 2.25652 1.57721 2.09985 2.01721 2.09985H14.8172C15.2572 2.09985 15.6339 2.25652 15.9472 2.56985C16.2605 2.88319 16.4172 3.25985 16.4172 3.69985V13.2999C16.4172 13.7399 16.2605 14.1165 15.9472 14.4299C15.6339 14.7432 15.2572 14.8999 14.8172 14.8999H2.01721ZM8.41721 9.15985C8.48387 9.15985 8.55387 9.14985 8.62721 9.12985C8.70054 9.10985 8.77054 9.07985 8.83721 9.03985L14.4972 5.49985C14.6039 5.43319 14.6839 5.34985 14.7372 5.24985C14.7905 5.14985 14.8172 5.03985 14.8172 4.91985C14.8172 4.65319 14.7039 4.45319 14.4772 4.31985C14.2505 4.18652 14.0172 4.19319 13.7772 4.33985L8.41721 7.69985L3.05721 4.33985C2.81721 4.19319 2.58387 4.18985 2.35721 4.32985C2.13054 4.46985 2.01721 4.66652 2.01721 4.91985C2.01721 5.05319 2.04387 5.16985 2.09721 5.26985C2.15054 5.36985 2.23054 5.44652 2.33721 5.49985L7.99721 9.03985C8.06387 9.07985 8.13387 9.10985 8.20721 9.12985C8.28054 9.14985 8.35054 9.15985 8.41721 9.15985Z"
      fill="white"
    />
  </svg>
))

export { MailIcon }
